<form [formGroup]="contractForm">
  <div class="form-section">
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <label for="type" class="form-label">{{
            "inputs.type" | translate
          }}</label>
          <div class="input-group">
            <select
              id="type"
              class="form-control"
              formControlName="type"
              (change)="changeType($event)"
            >
              <option value="" disabled selected>
                {{ "inputs.select_option" | translate }}
              </option>
              <option *ngFor="let type of type_" [value]="type">
                {{ "inputs." + type | translate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-6 mb-3">
        <div class="mb-2">
          <label for="initial_payment" class="form-label">{{
            "inputs.initial_payment" | translate
          }}</label>
          <div class="currencydiv">
            <input
              type="text"
              class="form-control"
              id="initial_payment"
              required
              formControlName="initial_payment"
              placeholder="{{ 'inputs.initial_payment' | translate }}"
            />
            <span> EUR</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">{{ "inputs.include" | translate }}</label>

      <!-- Seguro -->
      <div class="form-check require-action">
        <input class="form-check-input" type="checkbox" formControlName="include_insurance" />
        <label class="form-check-label">{{ "inputs.insurance" | translate }}</label>
      </div>
      <div class="row mt-1 mb-4" *ngIf="contractForm.get('include_insurance')?.value">
        <div class="col-6">
          <label class="form-label text-muted" style="font-size:0.8rem">{{ 'inputs.insurance_notes' | translate }}</label>
          <select class="form-control form-select mb-2" formControlName="insurance_notes_option">
            <option value="">{{ 'inputs.select_option' | translate }}</option>
            <option *ngFor="let opt of insuranceNotesOptions" [value]="opt.key">{{ opt.label }}</option>
          </select>
          <textarea *ngIf="contractForm.get('insurance_notes_option')?.value === 'other'"
            class="form-control" formControlName="insurance_notes" rows="2" style="resize:none"
            placeholder="{{ 'inputs.insurance_notes_custom' | translate }}"></textarea>
        </div>
        <div class="col-6">
          <label class="form-label text-muted" style="font-size:0.8rem">{{ 'inputs.insurance_deductible' | translate }}</label>
          <div class="currencydiv">
            <input type="number" class="form-control" formControlName="insurance_deductible" min="0" />
            <span> EUR</span>
          </div>
        </div>
      </div>

      <!-- Mantenimiento -->
      <div class="form-check require-action">
        <input class="form-check-input" type="checkbox" formControlName="include_maintenance" />
        <label class="form-check-label">{{ "inputs.maintance" | translate }}</label>
      </div>
      <div class="row mt-1 mb-4" *ngIf="contractForm.get('include_maintenance')?.value">
        <div class="col-12"><label class="form-label text-muted" style="font-size:0.8rem">{{ 'inputs.maintenance_notes' | translate }}</label></div>
        <div class="col-8">
          <textarea class="form-control" formControlName="maintenance_notes" rows="3" style="resize:none"></textarea>
        </div>
      </div>

      <!-- Neumáticos -->
      <div class="form-check require-action">
        <input class="form-check-input" type="checkbox" formControlName="include_tires" />
        <label class="form-check-label">{{ "inputs.tires" | translate }}</label>
      </div>
      <div class="row mt-1 mb-4" *ngIf="contractForm.get('include_tires')?.value">
        <div class="col-12"><label class="form-label text-muted" style="font-size:0.8rem">{{ 'inputs.tires_notes' | translate }}</label></div>
        <div class="col-8">
          <textarea class="form-control" formControlName="tires_notes" rows="3" style="resize:none"></textarea>
        </div>
      </div>

      <!-- Vehículo de sustitución -->
      <div class="form-check require-action">
        <input class="form-check-input" type="checkbox" formControlName="include_replacement_vehicle" />
        <label class="form-check-label">{{ "inputs.replacement_vehicle" | translate }}</label>
      </div>
      <div class="row mt-1 mb-4" *ngIf="contractForm.get('include_replacement_vehicle')?.value">
        <div class="col-12"><label class="form-label text-muted" style="font-size:0.8rem">{{ 'inputs.replacement_vehicle_notes' | translate }}</label></div>
        <div class="col-8">
          <textarea class="form-control" formControlName="replacement_vehicle_notes" rows="3" style="resize:none"></textarea>
        </div>
      </div>
    </div>

    <div class="row linea"></div>

    <label for="type" class="form-label">{{
      "inputs.matrix_price" | translate
    }}</label>
    <div>
      <div
        class="d-flex gap-2 mb-2 align-items-center justify-content-between"
       
      >
        <div>
          <span  *ngIf="campaignData.stage == 'paused' || campaignData.stage == 'draft'">
            <button
              type="button"
              (click)="addColumn()"
              class="btn btn-primary btn-primary-form"
            >
              +
            </button>
            Agregar Columna
          </span>
          <span  *ngIf="campaignData.stage == 'paused' || campaignData.stage == 'draft'">
            <button
              type="button"
              (click)="addRow()"
              class="btn btn-primary btn-primary-form"
            >
              +
            </button>
            Agregar Fila
          </span>
        </div>
        <div>
          <input
            #ivaCheckbox
            class="form-check-input"
            type="checkbox"
            value=""
            id="iva_included"
            (change)="onCheckboxChange($event)"
            checked
            [disabled]="campaignData.stage !== 'paused' && campaignData.stage !== 'draft'"
          />
          <label class="form-check-label" for="iva_included">
            {{ "forms.buttons.iva_included" | translate }}
          </label>
        </div>
        <!-- <div class="currencydiv">
        <input type="text" class="form-control" id="matrix_tax" required formControlName="matrix_tax" placeholder="%" />
      </div> -->
      </div>
      <div class="class">
        <span class="text-secondary">
          {{ "forms.labels.matrix_price_info" | translate }}
        </span>
      </div>
      <form [formGroup]="matrixForm" *ngIf="campaignData.stage == 'paused' || campaignData.stage == 'draft' ">
        <div class="tabla">
          <table
            mat-table
            class="full-width-table table-fixed"
            matSort
            aria-label="Brands"
            multiTemplateDataRows
          >
            <!-- Cabecera (encabezados editables) -->
            <thead>
              <tr>
                <th class="px-2 py-1 cabecera-tabla">KMS / Duration</th>
                <th *ngFor="let h of headers.controls; let c = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
                  <span></span>
                  <input [formControl]="h" class="inputs border px-1" />
                </th>
              </tr>
            </thead>
            <tbody formArrayName="rows">
              <tr *ngFor="let row of rows.controls; let r = index; trackBy: trackByIndex" [formGroupName]="r">
                <td class="px-2 py-1 row-label-cell">
                  <input formControlName="label" class="inputs border px-1" />
                </td>
                <ng-container formArrayName="cells">
                  <td *ngFor="let _ of row.get('cells')?.value; let c = index; trackBy: trackByIndex" class="px-1">
                    <input [formControlName]="c" class="inputs border px-1" (input)="matrixValuesChanged.emit()" />
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
      <div *ngIf="campaignData.stage != 'paused' && campaignData.stage != 'draft'">
        <div class="tabla">
          <table class="full-width-table table-fixed">
            <thead>
              <tr>
                <th class="px-2 py-1 cabecera-tabla">KMS / Duration</th>
                <th *ngFor="let h of headers.controls; let c = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
                
                 {{ h.value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows.controls; let r = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
                <td class="px-2 py-1 row-label-cell">
                 {{ row.value.label }}
                </td>
                <ng-container *ngIf="row.get('cells')">
                  <td *ngFor="let cell of row.get('cells')?.value; let c = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
                   {{ cell }}
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</form>
